import { render } from "./CreateNewCallQueue.vue?vue&type=template&id=70c7fdba&scoped=true"
import script from "./CreateNewCallQueue.vue?vue&type=script&lang=js"
export * from "./CreateNewCallQueue.vue?vue&type=script&lang=js"

import "./CreateNewCallQueue.vue?vue&type=style&index=0&id=70c7fdba&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c7fdba"]])

export default __exports__